import React from "react";
import { SiteHeader } from "@/components/landing/SiteHeader";
import { HeroSection } from "@/components/landing/HeroSection";
import { MarqueeStrip } from "@/components/landing/MarqueeStrip";
import { PillarsSection } from "@/components/landing/PillarsSection";
import { ScienceSection } from "@/components/landing/ScienceSection";
import { AppSection } from "@/components/landing/AppSection";
import { EbookCapture } from "@/components/landing/EbookCapture";
import { CoachShowcase } from "@/components/landing/CoachShowcase";
import { PricingSection } from "@/components/landing/PricingSection";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { FaqSection } from "@/components/landing/FaqSection";
import { FinalCta } from "@/components/landing/FinalCta";
import { SiteFooter } from "@/components/landing/SiteFooter";
import { ExitIntentOffer } from "@/components/ExitIntentOffer";

export default function Landing() {
  return (
    <div className="min-h-screen bg-afwn-bg text-afwn-navy overflow-x-hidden">
      <SiteHeader />
      <HeroSection />
      <MarqueeStrip />
      <PillarsSection />
      <ScienceSection />
      <AppSection />
      <EbookCapture />
      <CoachShowcase />
      <PricingSection />
      <TestimonialsSection />
      <FaqSection />
      <FinalCta />
      <SiteFooter />
      <ExitIntentOffer />
    </div>
  );
}
